<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="Spinner" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
<section
  class="section-reservation-hour"
  [formGroup]="formValidation"
  [ngClass]="{ isLoading: isLoading }"
>
  <div class="reservation">
    <app-my-reservation
      [tip_service]="ToSName"
      [kilometraje]="formValidation.value.kilometraje"
      [taller]="workShopName"
      [asesor]="advisorName"
      [date]="date"
      [time]="time"
      [cityName]="cityName"
      [LanguageForCountry]="recievedLanguageForCountry"
    ></app-my-reservation>
  </div>
  <div class="content-reservation-hour">
    <mat-stepper class="choose-service">
      <!-- <mat-step
        class="item-step-service step-1"
        [stepControl]="formValidation"
        completed="false"
      > -->
      <mat-step [stepControl]="firstFormGroup" >
        <form [formGroup]="formValidation">
          <ng-template matStepperIcon="number" let-index="index">
            <span>{{ index + 1 }}.</span>
          </ng-template>
          <ng-template matStepLabel> {{ "SelectYourService" | translate | uppercase}} </ng-template>

          <div class="grid-container-service service-info">
            <div class="form-input-select">
              <p>{{"TypeOfService" |translate}} &nbsp;<i *ngIf="TermAndConditiosMode === 'Derco'"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                #tooltip="matTooltip"
                (click)="onIconClick('exclamation', 'bi-exclamation-circle', tooltip)"
                matTooltip={{tooltip}}
                matTooltipPosition="above"

              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select formControlName="tip_service" (selectionChange)="onChangeTypeOfService($event.value)">
                  <mat-option
                    *ngFor="let typeOfService of typesOfservice"
                    [value]="typeOfService.serviceId"

                  >
                    {{ typeOfService.serviceName  | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  tip_serviceControl?.invalid &&
                  (tip_serviceControl?.touched || tip_serviceControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-select">
              <p>{{"Mileage" |translate}}<i *ngIf="recievedCountryData  === 3"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                #tooltip="matTooltip"
                (click)="onIconClick('exclamation', 'bi-exclamation-circle', tooltip)"
                matTooltip={{disclaimer}}
                matTooltipPosition="above"

              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label> {{"Mileage" |translate}} </mat-label>
                <input matInput  formControlName="kilometraje"  autocomplete="off" oninput="value = value.replace(/[^0-9]/g, '')" maxlength="6"/>
                <!-- <mat-select formControlName="kilometraje">
                  <mat-option
                    *ngFor="let mileage of mileages"
                    [value]="mileage"
                  >
                    {{ mileage }}
                  </mat-option>
                </mat-select> -->
              </mat-form-field>
              <div
                *ngIf="
                  kilometrajeControl?.invalid &&
                  (kilometrajeControl?.touched || kilometrajeControl?.dirty)
                "
              >
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['required']"
                >
                  {{"ObligatoryField" |translate}}
                </p>
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['pattern']"
                >
                  {{"ObligatoryNumbers" |translate}}
                </p>
              </div>
            </div>

            <div class="form-input-select">
              <p>{{"Workshop" |translate}} &nbsp;<i *ngIf="TermAndConditiosMode === 'Derco'"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                #tooltip="matTooltip"
                (click)="onIconClick('exclamation', 'bi-exclamation-circle', tooltip)"
                matTooltip={{tooltipWorkshop}}
                matTooltipPosition="above"

              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select
                  formControlName="taller"
                  (selectionChange)="onWorkshopChange($event.value)"
                >
                  <mat-option
                    *ngFor="let workshop of workshops"
                    [value]="workshop.workshopId"

                  >
                    {{ workshop.workshopName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  tallerControl?.invalid &&
                  (tallerControl?.touched || tallerControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-select">
              <p>{{"Advisor" |translate}}</p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select
                  formControlName="asesor"
                  (selectionChange)="onAdvisorChange($event.value)"
                >
                  <mat-option

                    *ngFor="let advisor of advisors"
                    [value]="advisor.advisorId"

                  >
                    {{advisor.advisorFullName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  asesorControl?.invalid &&
                  (asesorControl?.touched || asesorControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-area">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{"Observations" |translate}}</mat-label>
                <textarea
                  matInput
                  formControlName="observations"
                  maxlength="4000"
                  placeholder= {{PlaceHolderObservations}}
                  oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="Spinner" *ngIf="isLoadingCalendar"><mat-spinner></mat-spinner></div>
          <!---------------------Espacio Calendario---------------------->
          <app-calendarweb
            *ngIf="showCalendar"
            (timeChanged)="timeValue($event)"
            (dateChanged)="dateValue($event)"
            [timeListButtons]="timeButtons"
            [serviceAdvisorAttention]="serviceAdvisorAttention"
            [dateFilter]="DateFilter"
            [advisorBlockedSchedule]="serviceAdvisorBlockedSchedule"
            [dealerBlockedServices]="dealerBlockedServices"
            [typeOfServiceSelected]="toNumber(formValidation.value.tip_service)"
            [unavaibleAdvisorHours]="unavaibleAdvisorHours"
            [SchedulForAdvisor] ="SchedulForAdvisor"
            [typeOfServiceSelectedName]="ToSName"
            [LanguageForCountry]="recievedLanguageForCountry"
            [DataRange]="dateDuration"
          ></app-calendarweb>
          <!---------------------End Espacio Calendario--------------------->
          <!--<pre> {{ formValidation.value | json }}</pre>-->

          <div class="check-form">
            <div class="text-check" [innerHTML]="safeObservationsDescription" *ngIf="safeObservationsDescription && TermAndConditiosMode === 'Derco'"></div>
          </div>

          <div class="container-btn-reservation">
            <button mat-stroked-button class="btn-reservation"  (click)="backInitialChoose()">{{"Back" |translate}}</button>

            <button
              mat-raised-button
              class="btn-reservation-sig"
              type="button"
              matStepperNext
              [disabled]="nextDisabled()"
            >
            {{"Next" |translate}}
            </button>
          </div>
        </form>
      </mat-step>
      <!-- <mat-step class="item-step-service step-2" [stepControl]="formValidation2" label="Completa tus datos" > -->
      <mat-step [stepControl]="firstFormGroup" >
        <form [formGroup]="formValidation2">
          <ng-template matStepLabel>{{ "CompleteData" | translate | uppercase }}</ng-template>
          <section class="section-complete-reserv">
            <div class="content-complete-reserv">
              <div class="container-fomr" [formGroup]="formValidation2">
                <h3
                  class="input-title-blue"
                  *ngIf="TermAndConditiosMode === 'Derco' && isNewSchedule()"
                >
                {{"CustomerAndVehicleData" |translate}}
                </h3>
                <h3
                  class="input-title-blue"
                  *ngIf="TermAndConditiosMode !== 'Derco' && isNewSchedule()"
                >
                {{"CustomerAndVehicleData" |translate}}
                </h3>
                <h3
                  class="input-title-blue"
                  *ngIf="!isNewSchedule()"
                >
                {{"VehicleData" |translate}}
                </h3>
                <div class="content-data">
                  <div *ngIf=" isNewSchedule()">
                    <p><strong class="personType">{{"PersonType" |translate}}</strong></p>
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-select formControlName="personTypeId">
                        <mat-option *ngFor="let personType of personTypes" [value]="personType.typeId">
                          {{ personType.typeName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div>
                      <p *ngIf="recievedCountryData !== 3 && !isNewSchedule()"><strong>{{"PersonType" |translate}}</strong></p>
                      <p *ngIf="recievedCountryData !== 3 && !isNewSchedule()">{{recievedScheduledData.personType}}</p>
                  </div>
                  <div class="form-input"  *ngIf=" isNewSchedule()">
                    <p *ngIf="isNewSchedule() && TermAndConditiosMode === 'Derco'"><strong>{{"IdDerco" |translate}}</strong></p>
                    <p *ngIf="isNewSchedule() && recievedCountryData === 3"><strong>{{"Rut" |translate}}</strong></p>
                    <p *ngIf="isNewSchedule() && recievedCountryData !== 3 && TermAndConditiosMode !== 'Derco'"><strong>{{"Identification" |translate}}</strong></p>
                    <mat-form-field appearance="outline" *ngIf="isNewSchedule()">
                      <input matInput formControlName="cedula"
                        maxlength="20"
                        autocomplete="off"
                       oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')" />
                    </mat-form-field>
                    <div *ngIf="recievedCountryData === 3">
                    <p class="mensagePatentModel">
                    {{"Example"|translate}}: 1111111-1
                    </p>
                    </div>

                  <div *ngIf=" cedulaControl?.invalid &&(cedulaControl?.touched || cedulaControl?.dirty)">
                    <p class="error-ms" *ngIf="cedulaControl.errors?.['required']">{{"ObligatoryField" |translate}} </p>
                    <p class="error-ms"*ngIf="cedulaControl.errors?.['pattern']"> {{"ObligatoryNumbers" |translate}}</p>
                    <p class="error-ms" *ngIf="cedulaControl.errors?.['minlength']"> {{ (recievedCountryData === 1 ? "MinimumCharactersCo" : "MinimumCharacters") | translate }} </p>
                    <p class="error-ms" *ngIf="cedulaControl.errors?.['maxlength']"> {{"MaximumCharactersCo" |translate}} </p>
                  </div>
                </div>
                <div class="form-input">
                  <p *ngIf="recievedCountryData === 3"><strong>{{"Patent" |translate}}</strong></p>
                  <p *ngIf="recievedCountryData !== 3"><strong>{{"Plate"|translate}}</strong></p>
                  <div class="plate-cont">
                    <mat-form-field appearance="outline" *ngIf=" isNewSchedule()">
                      <input
                        matInput
                        formControlName="placa"
                        autocomplete="off"
                        maxlength="10"
                       oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                        (change)="transformInput($event)"
                      />

                    </mat-form-field>
                    <p *ngIf=" !isNewSchedule()">{{formValidation2.value.placa}}</p>
                    <button
                      mat-raised-button
                      [disabled]="SerchPlate()"
                      class="btn-icon"
                      *ngIf="isNewSchedule()"
                      (click)="onPlateNumberSearchClick()"
                    >
                      <!-- <i  *ngIf="recievedCountryData !== 3" class="bi bi-search"></i> -->
                      <i class="bi bi-search" ></i>
                    </button>
                  </div>
                  <div
                  *ngIf="recievedCountryData === 3 && isNewSchedule()"
                >
                  <p
                    class="mensagePatentModel"

                  >
                 {{"Example"|translate}}: AABB12
                  </p>
                </div>

                <div
                *ngIf="TermAndConditiosMode === 'Derco'"
              >
                <p
                  class="mensagePatentModel"

                >
               {{"Example"|translate}}: XYZ123
                </p>
              </div>

                  <div
                    *ngIf="
                      placaControl?.invalid &&
                      (placaControl?.touched || placaControl?.dirty)
                    "
                  >
                    <p
                      class="error-ms"
                      *ngIf="placaControl.errors?.['required']"
                    >
                      {{"ObligatoryField" |translate}}
                    </p>
                  </div>
                </div>
              </div>
                <br>
                <br>
                <div class="Spinner" *ngIf="loadingSerchPlate"><mat-spinner></mat-spinner></div>
                <div class="fill-details" *ngIf="details === isNewSchedule()">
                  <h3 *ngIf="edited === true && isNewSchedule()" class="input-title-blue">
                    {{"VerifyDataOwner" |translate}}
                  </h3>
                  <h3 *ngIf="edited2 === false && isNewSchedule()" class="input-title-blue">
                    {{"CompleteDataOwner" |translate}}
                  </h3>
                  <h3 *ngIf="!isNewSchedule()" class="input-title-blue">
                    {{"YourData" |translate}}
                  </h3>
                  <div class="grid-container-service owner-info">
                    <div class="form-input-select">
                      <div class="item-form">
                        <div>
                          <p><strong>{{"DocumentType" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="tip_Doc" >
                              <mat-option
                                *ngFor="let typeofdocument of documentType"
                                [value]="typeofdocument.typeId"

                              >
                                {{ typeofdocument.typeName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div
                            *ngIf="
                              tip_DocControl?.invalid &&
                              (tip_DocControl?.touched || tip_DocControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="tip_DocControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p><strong>{{"NumerDocument" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="cedula"
                            autocomplete="off"
                           oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="20" />
                          </mat-form-field>

                          <div
                            *ngIf="
                              cedulaControl?.invalid &&
                              (cedulaControl?.touched || cedulaControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['pattern']"
                            >
                              {{"ObligatoryNumbers" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['minlength']"
                            >
                              {{ (recievedCountryData === 1 ? "MinimumCharactersCo" : "MinimumCharacters") | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['maxlength']"
                            >
                              {{"MaximumCharactersCo" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div>
                          <p><strong>{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') |translate}}</strong></p>

                          <mat-form-field appearance="outline" >
                            <input matInput formControlName="nombres"
                            autocomplete="off"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="100"/>
                          </mat-form-field>
                          <div
                            *ngIf="
                              nombresControl?.invalid &&
                              (nombresControl?.touched || nombresControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="nombresControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>

                        <div *ngIf="showApellidos">
                          <p><strong>{{"LastName" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="apellidos"
                            autocomplete="off"
                            oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="100"/>
                          </mat-form-field>
                          <div
                            *ngIf="
                              apellidosControl?.invalid &&
                              (apellidosControl?.touched ||
                                apellidosControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="apellidosControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">

                        <div>
                          <p><strong>{{"Phone" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <mat-label>{{"Phone" |translate}}</mat-label>

                            <input matInput formControlName="celular"
                            autocomplete="off"
                            (input)="filterPhoneByCountry($event, celControl)"
                              maxlength="20" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              celControl?.invalid &&
                              (celControl?.touched || celControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['pattern']"
                            >
                              {{"ObligatoryNumbers" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['minlength']"
                            >
                              {{ (recievedCountryData === 1 ? "MinimumPhoneCharactersCo" : "MinimumCharacters") | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['maxlength']"
                            >
                              {{"MaximumPhoneCharactersCo" |translate}}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p><strong>{{"Email" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="correo"
                            autocomplete="off"
                             style="max-width: 400px;"
                              maxlength="100"/>
                          </mat-form-field>
                          <div
                            *ngIf="
                              correoControl?.invalid &&
                              (correoControl?.touched || correoControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['invalidEmail']"
                            >
                            {{"Invalidemail" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-input">
                      <div class="item-form-input">

                         <div>
                          <p><strong>{{"year" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="año" [disabled]="EnableVehicleandModel">
                              <mat-option
                                *ngFor="let YearsShowData of YearsShow"
                                [value]="YearsShowData"

                              >
                                {{ YearsShowData }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div
                            *ngIf="
                              yearControl?.invalid &&
                              (yearControl?.touched || yearControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="yearControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p><strong>{{"Model" |translate}}</strong></p>
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="model" [disabled]="EnableVehicleandModel"  >
                              <mat-option
                                *ngFor="let typeofdocument of modelVehicle"
                                [value]="typeofdocument"

                              >
                                {{ typeofdocument }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div
                            *ngIf="
                              ModelControl?.invalid &&
                              (ModelControl?.touched || ModelControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="ModelControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div  *ngIf="!isNewUser">

                          <p><strong>VIN</strong></p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="vin"
                           oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                            autocomplete="off"
                              maxlength="20"/>
                          </mat-form-field>
                          <div
                            *ngIf="
                              vinControl?.invalid &&
                              (vinControl?.touched || vinControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="vinControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info-owner" *ngIf="details === isNewSchedule()">
                  <div class="container-raddio" >
                    <h3>{{"OwnerWillBeOnSite" |translate}}</h3>
                    <div class="custom-radio">
                      <input
                        #isOwnerRadio
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        value="true"
                        type="radio"
                        [(ngModel)] = "selectOwnerOnSite"
                        id="custom-radio1"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio1">{{"Yes" |translate}}</label>
                    </div>
                    <div class="custom-radio">
                      <input
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        type="radio"
                        id="custom-radio2"
                        value="false"
                        [(ngModel)] ="selectOwnerOnSite"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio2">No</label>
                    </div>
                  </div>
                  <!--AQUI TERMINA EL FORMULARIO COMPLETE DATOS DEL PROPIETARIO-->
                  <div
                    class="section-representante"
                    *ngIf="isOwnerOnSite === false && details === isNewSchedule()"
                    [formGroup]="formValidation_representative"
                  >
                    <h3 class="input-title-blue">{{"RepresentativeData" |translate}}</h3>
                    <div class="grid-container-service representative-info">
                      <div class="form-input-select">
                        <div class="item-form">
                          <div>
                            <p><strong>{{"DocumentType" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <mat-label>{{"Select" |translate}}</mat-label>

                              <mat-select
                                formControlName="representativeDocumentType"
                              >
                                <mat-option
                                *ngFor="let typeofdocument of documentType"
                                [value]="typeofdocument.typeId"
                              >
                                {{ typeofdocument.typeName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentTypeControl?.invalid &&
                                (representativeDocumentTypeControl?.touched ||
                                  representativeDocumentTypeControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentTypeControl.errors?.['required']"
                              >
                                El campo es Obligatorio
                              </p>
                            </div>
                          </div>

                          <div>
                            <p><strong>{{"NumerDocument" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeDocumentNumber"
                                oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                                maxlength="20"/>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentNumberControl?.invalid &&
                                (representativeDocumentNumberControl?.touched ||
                                  representativeDocumentNumberControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['pattern']"
                              >
                                {{"ObligatoryNumbers" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['minlength']"
                              >
                                {{(recievedCountryData === 1 ? "MinimumCharactersCo" : "MinimumCharacters") | translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['maxlength']"
                              >
                                {{"MaximumCharactersCo" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input">
                        <div class="item-form-input">
                          <div>
                            <p><strong>{{"FirstName" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeName"
                               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                                maxlength="100"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeNameControl?.invalid &&
                                (representativeNameControl?.touched ||
                                  representativeNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeNameControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>

                          <div>
                            <p><strong>{{"LastName" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <!-- [(ngModel)]="ownerLastName" -->
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeLastName"
                               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                                maxlength="100"/>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeLastNameControl?.invalid &&
                                (representativeLastNameControl?.touched ||
                                  representativeLastNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeLastNameControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input-select">
                        <div class="item-form">
                          <!-- <div>
                            <p>{{"CodCountry" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <mat-select
                                formControlName="representativeCountryCode"

                              >
                                <mat-option
                                  *ngFor="let codeRep of codesRep"
                                  [value]="codeRep"

                                >
                                  {{ codeRep }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeCountryCodeControl?.invalid &&
                                (representativeCountryCodeControl?.touched ||
                                  representativeCountryCodeControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeCountryCodeControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div> -->

                          <div>
                            <p><strong>{{"Phone" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativePhone"
                                (input)="filterPhoneByCountry($event, representativePhoneControl)" />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativePhoneControl.invalid &&
                                (representativePhoneControl.touched ||
                                  representativePhoneControl.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['pattern']"
                              >
                                {{"ObligatoryNumbers" |translate}}
                              </p>
                              <p class="error-ms" *ngIf="representativePhoneControl.errors?.['minlength']">
                              {{ (recievedCountryData === 1 ? "MinimumPhoneCharactersCo" : "MinimumCharacters") | translate }}
                              </p>
                              <p class="error-ms" *ngIf="representativePhoneControl.errors?.['maxlength']">
                                {{ "MaximumPhoneCharactersCo" | translate }}
                              </p>
                            </div>
                          </div>
                          <div>
                            <p><strong>{{"Email" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <input matInput formControlName="representativecorreo"
                              autocomplete="off"
                                maxlength="100"/>
                            </mat-form-field>
                            <div
                              *ngIf="
                              representativecorreoControl?.invalid &&
                                (representativecorreoControl?.touched || representativecorreoControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['invalidEmail']"
                              >
                              {{"Invalidemail" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-input">
                        <div class="item-form-input">

                          <div>
                            <p><strong>{{"RelationOwner" |translate}}</strong></p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeRelationWithOwner"
                                maxlength="20"
                                oninput="value = value.replace(/[^a-zA-Z]/g, '')"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeRelationWithOwnerControl?.invalid &&
                                (representativeRelationWithOwnerControl?.touched ||
                                  representativeRelationWithOwnerControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeRelationWithOwnerControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>
                  <br>
                  <br>

                  <div class="check-form representante" *ngIf="isOwnerOnSite === false">
                    <mat-checkbox
                      class="check"
                      [color]="task.color"
                      formControlName="canTakeDecision"
                    ></mat-checkbox>
                    <div class="text-check">
                      {{"Representative" | translate}}
                    </div>
                  </div>
                  <!-- Chile (BMW, Mini, Motorrad), Peru (BMW, Mini, Motorrad - Subaru, DFSK) -->
                  <div class="check-form">
                    <div class="text-check" [innerHTML]="safeObservationsDescription" *ngIf="safeObservationsDescription && TermAndConditiosMode !== 'Derco'"></div>
                  </div>
                  <!-- Colombia, Bélgica, Derco son diferentes, el resto es default -->
                  <div class="check-form" *ngIf="!isPeruSpecialBrand()">           
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check" [innerHTML]="safeTermsAndConditionsDescription" *ngIf="safeTermsAndConditionsDescription"></div>
                  </div>

                  <!-- Peru, marcas 4, 5 y 6 (recievedCountryData === 2) -->
                  <div class="check-form check-form-center" *ngIf="isPeruSpecialBrand()">
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">Deseo conocer y entender la Política de Protección de Datos Personales y autorizo expresamente el tratamiento de mis datos personales</div>
                  </div>
                  <!-- Colombia, Chile, Bélgica, son diferentes, el resto es default -->
                  <div class="check-form" *ngIf="recievedCountryData !== 1 && !isPeruSpecialBrand()">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check" [innerHTML]="safeDataProcessingPolicy" *ngIf="safeDataProcessingPolicy"></div>
                  </div>

                  <!-- Peru, marcas 4, 5 y 6 (recievedCountryData === 2) -->
                  <div class="check-form" *ngIf="isPeruSpecialBrand()">

                    <!-- Las políticas de Peru vienen con cláusula -->

                    <div *ngIf="safeDataProcessingPolicy">
                      <div class="text-check text-check-no-padding" [innerHTML]="safeDataProcessingPolicy"></div>
                      <mat-radio-group aria-label="Select an option" formControlName="dataPeru">
                        <mat-radio-button [value]="true" labelPosition="after" class="custom-radio custom-radio-checkbox">
                          <span class="mat-radio-label-content text-check" [innerHTML]="safeDataProcessingPolicyTrue"></span>
                        </mat-radio-button>
                        <br>
                        <mat-radio-button [value]="false" labelPosition="after" class="custom-radio">
                          <span class="mat-radio-label-content text-check" [innerHTML]="safeDataProcessingPolicyFalse"></span>

                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  
                  <div class="check-form habeasDataCol" *ngIf=" recievedCountryData === 1">
                  
                    <!-- Las políticas de Peru vienen con cláusula -->
                   <div>
                      <div class="text-check" [innerHTML]="safeDataProcessingPolicy"></div>
                     <br>
                      <br>
                       <br>
                      <mat-radio-group aria-label="Select an option" formControlName="politics" >
                        <mat-radio-button
                          [value]="true"
                          labelPosition="after"
                          class="custom-radio custom-radio-checkbox"
                        >
                        <span class="mat-radio-label-content text-check" [innerHTML]="safeDataProcessingPolicyTrue"></span>
                        </mat-radio-button>
                        <br>
                        <mat-radio-button
                          [value]="false"
                          labelPosition="after"
                          class="custom-radio"
                        >
                        <span class="mat-radio-label-content text-check" [innerHTML]="safeDataProcessingPolicyFalse"></span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                  
                   <!-- Peru Form term and conditions -->


                   <!-- <div class="check-form"  *ngIf="TermAndConditiosMode === 'Peru'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Legales:
                      <li>En el caso de agendamiento vía Web eventualmente se hará una llamada telefónica para solicitar más información acerca de los servicios solicitados y reagendar una nueva cita de forma de entregar la atención más adecuada al requerimiento.</li>
                      <li>En caso de que el trabajo requiera repuestos u otros, el cliente podría ser contactado para reagendar una nueva cita, según la disponibilidad de los repuestos o implementos necesarios.</li>
                      <li>Declaro conocer y entender la <a href="https://www.inchcapemotors.pe/bmw/advertencia-legal">Política de Protección de Datos Personales</a>  y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales a Inchcape PLC y BMW México SA de CV para fines promocionales, comerciales o publicitarios.</li>
                      <li>Vehículos con campaña técnica, falla mecánica o mantención a partir de 40.000 km podrían no ser entregados el mismo día de entrega, dependiendo de la complejidad del caso.</li>
                     </div>
                  </div> -->
                  <!-- <div class="check-form"  *ngIf="TermAndConditiosMode === 'Peru2'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Legales:
                      <li>Declaro conocer y entender <a href="https://www.subaru.com.pe/autorizacion-para-el-tratamiento-de-datos-personales"> la Política de Protección de Datos Personales</a> y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales para fines promocionales, comerciales o publicitarios.</li>
                      </div>
                  </div> -->

                <!-- <div class="check-form"  *ngIf="TermAndConditiosMode === 'Derco'">
                  <mat-checkbox
                    formControlName="politics"
                    class="check"
                    [color]="task.color"
                    required
                  ></mat-checkbox>
                  <div class="text-check">
                    Legales:
                    <li>Declaro conocer y entender la Política de Protección de Datos Personales y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales para fines promocionales, comerciales o publicitarios.</li>
                    </div>
                </div> -->

                 <!-- checkbox only peru -->

                  <div class="container-btn-reservation">
                    <button
                      mat-stroked-button
                      class="btn-reservation"
                      matStepperPrevious
                    >
                     {{"Back"|translate}}
                    </button>

                    <button
                      mat-raised-button
                      class="btn-reservation-sig"
                      type="button"
                      matStepperNext
                      [disabled]="formsValidations()"
                      (click)="NameDocument()"
                    >
                    {{"Next"|translate}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
      </mat-step>
      <!-- <mat-step [stepControl]="formValidation" label="{{FinalizeReservationr |translate}}:"> -->
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel> {{ "FinalizeReservationr" | translate | uppercase}}</ng-template>
        <form class="section-finalize-reservation">
          <div class="content-finalize-reservation">
            <h3 class="input-title-blue">{{"VerifyYourDetails"|translate}}:</h3>
            <div class="container-form-finalize">
              <div class="item-form-finalize">
                <p><strong>{{"DocumentType" |translate}}</strong></p>
                <p>{{ nameDocumentType?.typeName || '-' }}</p>
              </div>
              <div class="item-form-finalize">
                <p><strong>{{"NumerDocument" |translate}}</strong></p>
                <p>{{ formValidation2.controls.cedula.value }}</p>
              </div>
              <div class="item-form-finalize">
                <p><strong>{{(companyType === 'Company' ? 'CompanyType' : 'FirstName') |translate}}</strong></p>
                <p class="name-field">{{ formValidation2.controls.nombres.value }}</p>
              </div>
              <div *ngIf="showApellidos" class="item-form-finalize">
                <p><strong>{{"Surname" |translate}}</strong></p>
                <p class="name-field">{{ formValidation2.controls.apellidos.value }}</p>
              </div>

              <!-- <div class="item-form-finalize">
                <p>{{"CodCountry" |translate}}</p>
                <h3>{{ this.formValidation2.value.cod_pais }}</h3>
              </div> -->
              <div class="item-form-finalize">
                <p><strong>{{"Phone" |translate}}</strong></p>
                <p >{{ formValidation2.controls.celular.value }}</p>
              </div>
              <div class="item-form-finalize">
                <p><strong>{{"Email" |translate}}</strong></p>
                <p class="name-field">{{ formValidation2.controls.correo.value }}</p>
              </div>
              <div class="item-form-finalize"  *ngIf="!isNewUser">
                <p><strong>VIN</strong></p>
                <p>{{ formValidation2.controls.vin.value }}</p>
              </div>
            </div>
            <div class="container-btn-reservation">
              <button
                mat-stroked-button
                class="btn-reservation"
                matStepperPrevious
              >
              {{"Back"|translate}}
              </button>

              <button
                mat-raised-button
                class="btn-finalize-reservation"
                type="submit"
                (click)="ejecutarCaptcha()"
              >
                {{"FinalizeReservation" |translate}}
              </button>

              <!-- No se muestra nada visualmente, es invisible -->
             

            </div>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
</section>
